<template>
  <div>
    <lk-form :model='data.patient' :rules='validate' :label-width='110' ref="patient"
      label-position="right">
      <lk-row :gutter='16'>
        <lk-col :span='7'>
          <lk-form-item label='患者姓名:' prop='name'>
            <lk-input v-model="data.patient.name" v-if="able" disabled></lk-input>
            <span v-else>{{data.patient.name}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col :span='7' offset='1'>
          <lk-form-item label='联系方式:' prop='phone'>
            <lk-input v-model="data.patient.phone" v-if="able"></lk-input>
            <span v-else>{{data.patient.phone}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col :span='7' offset='1'>
          <lk-form-item label='患者性别:' prop='gender'>
            <lk-radio-group v-model="data.patient.gender" v-if="able">
              <lk-radio :label='1'>男</lk-radio>
              <lk-radio :label='2'>女</lk-radio>
            </lk-radio-group>
            <span v-else>{{publicParams.genderList[ data.patient.gender]}}</span>
          </lk-form-item>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col :span='7'>
          <lk-form-item label='出生年月:' prop='birthday'>
            <timeStampDatePicker transfer v-model="data.patient.birthday" v-if="able">
            </timeStampDatePicker>
            <span v-else>{{data.patient.birthday|formatDate}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col :span='7' offset='1'>
          <lk-form-item label='证件号码:' prop='idCard'>
            <CredentialsInput v-model="data.patient" :able='able'
            codeKey='idCard' @setRules='setRules'
            ></CredentialsInput>
            <!-- <lk-input v-model="data.patient.idCard" v-if="able" @on-blur='checkBirthDay'></lk-input> -->
            <!-- <span v-else>{{data.patient.idCard}}</span> -->
          </lk-form-item>
        </lk-col>
        <lk-col :span='7' offset='1'>
          <lk-form-item label='社保卡号:' prop='insuranceCode'>
            <lk-input v-model="data.patient.insuranceCode" v-if="able"></lk-input>
            <span v-else>{{data.patient.insuranceCode}}</span>
          </lk-form-item>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col :span='7'>
          <lk-form-item label='国籍:' prop='nationId'>
            <lk-select v-model="data.patient.nationId" v-if="able" :transfer='true'>
              <lk-option v-for="item in listNation" :key="item.id" :value='item.id'>{{item.name}}
              </lk-option>
            </lk-select>
            <span v-else>{{data.patient.nation}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col :span='7' offset='1'>
          <lk-form-item label='民族:' prop='ethnicityId'>
            <lk-select v-model="data.patient.ethnicityId" v-if="able" :transfer='true'>
              <lk-option v-for="item in listEthnicity" :key="item.id" :value='item.id'>{{item.name}}
              </lk-option>
            </lk-select>
            <span v-else>{{data.patient.ethnicity}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col :span='7' offset='1'>
          <lk-form-item label='婚姻状况:' prop='maritalStatus'>
            <lk-select v-model="data.patient.maritalStatus" v-if="able" transfer>
              <lk-option v-for="(item,i) in maritalStatusList" :key="i" :value='i*1'>{{item}}
              </lk-option>
            </lk-select>
            <span v-else>{{data.patient.maritalStatusName}}</span>
          </lk-form-item>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col :span='7'>
          <lk-form-item label='生存状况:' prop='LivingStatus'>
            <lk-select v-model="data.patient.livingStatus" v-if="able" transfer>
              <lk-option v-for="(item,i) in livingStatusList" :key="i" :value='i*1'>{{item}}
              </lk-option>
            </lk-select>
            <span v-else>{{livingStatusList[data.patient.livingStatus]}}</span>
          </lk-form-item>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col :span='23'>
          <lk-form-item label='家庭住址:'>
            <div class="editRow" v-if="able">
              <location style="width:40%" v-model="data.patient.locationArr"></location>
              <lk-input style="width:60%" v-model="data.patient.address"></lk-input>
            </div>
            <div v-else>
              <span>{{data.patient.locationString}}</span>
              <span>{{data.patient.address}}</span>
            </div>
          </lk-form-item>
        </lk-col>
      </lk-row>
      <lk-row :gutter='16'>
        <lk-col :span='23'>
          <lk-form-item label='其他联系人:'>
            <div>
              <div class="editRow mb8" v-for="(item,i) in data.patientOtherContactList" :key="i">
                <span v-if="able ">
                  <lk-input v-model="data.patientOtherContactList[i].name" placeholder='请输入姓名'>
                  </lk-input>
                  <lk-select :transfer='true' v-model="data.patientOtherContactList[i].relation"
                    placeholder='请选择关系'>
                    <lk-option v-for='(item,i) in otherContactRelationList' :key="i" :value='i*1'>
                      {{item}}</lk-option>
                  </lk-select>
                  <lk-input v-model="data.patientOtherContactList[i].phone" placeholder='请输入电话'>
                  </lk-input>
                </span>
                <span v-else>
                  <span>姓名：{{data.patientOtherContactList[i].name}} </span>
                  <span>关系：{{data.patientOtherContactList[i].relationName}} </span>
                  <span>电话：{{ data.patientOtherContactList[i].phone}}</span>
                </span>
                <span v-if="able">
                  <lk-button @click="handleContentAdd(i)">+</lk-button>
                  <lk-button v-show=" data.patientOtherContactList.length>1"
                    @click="handleContentDel(i)">-</lk-button>
                </span>
              </div>
            </div>
          </lk-form-item>
        </lk-col>
      </lk-row>
    </lk-form>
  </div>
</template>

<script>
import momnet from 'moment';
import location from '../location.vue';
import utils from '../../libs/utils';
import base from '../../services/base';

import mapState from '../../mixins/mapState';

import CredentialsInput from '../CredentialsInput';

export default {
  name: 'patientBaseInfo',
  mixins: [mapState],
  components: { location, CredentialsInput },
  props: {
    value: {

    },
    id: {

    },
    able: {
      type: Boolean,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    const birthdayValidate = (rule, value, callback) => {
      // console.log(this.data);
      if (this.data.patient.permissionType !== 1) {
        callback();
      }
      if (this.data.patient.idCard) {
        const birthday = new Date(this.data.patient.birthday).toDateString();
        const val = this.checkBirthDay({
          target: { value: this.data.patient.idCard },
        }).toDateString();
        const valid = val === birthday;

        if (valid) {
          callback();
        } else {
          callback(new Error('请输入与身份证匹配的出生日期'));
        }
      }

      callback();
    };
    return {

      data: {
        patient: {},
        patientOtherContactList: [{}],
      },
      validate: {
        name: [{ required: true, message: '请填写患者姓名' }],
        phone: [{ required: true, message: '请填写患者联系方式' },
          { validator: utils.validate.phoneValidator, trigger: 'blur' }],
        idCard: [
          { validator: utils.validate.credentialsValidate, trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.data.patient.permissionType !== 1) {
                callback();
              } else {
                console.log(value);
                value || callback();
                let birthday = null;
                if (value.length === 18) {
                  birthday = value.slice(6, 14);
                } else if (value.length === 15) {
                  birthday = value.slice(6, 12);
                }
                const isDate = momnet(this.IdToBirthDay(birthday)).isValid();


                if (!isDate) {
                  // this.$Message.error('请填写正确的身份证号');

                  callback(new Error('请输入正确的身份证号'));
                }
                if (birthday) {
                // this.$Message.info('出生日期已按照身份证更新');
                  this.$set(this.data.patient, 'birthday', new Date(this.IdToBirthDay(birthday)).getTime());
                }

                this.$refs.patient.validateField('birthday');


                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        birthday: [{
          validator: birthdayValidate,
          trigger: 'change',
        }],

      },
      registerTypeList: {
        1: '处方创建',
        2: '邻客智慧药房公众号',
        3: '邻客健康管家',
      },
      maritalStatusList: {
        1: '未婚',
        2: '已婚',
        3: '离异',
        4: '丧偶',
      },
      livingStatusList: {
        1: '治疗中',
        2: '痊愈',
        3: '死亡',
      },
      otherContactRelationList: {
        1: '本人',
        2: '父母',
        3: '子女',
        4: '朋友',
        5: '其他',
      },
      // isSubmit: false,
    };
  },
  // watch: {
  //   'data.patient.idCard': function () {

  //   },
  // },
  methods: {
    setRules(type) {
      this.validate.idCard[0].credentialsType = type;
    },
    IdToBirthDay(birthday) {
      // console.log(birthday);

      let year = '';
      if (birthday.length === 8) {
        year = birthday.slice(0, 4);
      } else if (birthday.length === 6) {
        year = `19${birthday.slice(0, 2)}`;
      }

      return `${year}-${birthday.slice(-4, -2)}-${birthday.slice(-2)}`;
    },
    checkBirthDay(e) {
      const { value } = e.target;

      let birthday = null;
      if (value.length === 18) {
        birthday = value.slice(6, 14);
      } else if (value.length === 15) {
        birthday = value.slice(6, 12);
      }

      if (birthday) {
        return new Date(this.IdToBirthDay(birthday));// .getTime();
      }
    },
    clearAll() {
      this.getData(this.id);
    },
    exchangeLocation(locationArr) { // 处理位置数组转换
      if (!locationArr || !locationArr.length) {
        return {};
      }
      const [provinceId, cityId, countyId] = locationArr;
      return {
        provinceId, cityId, countyId,
      };
    },
    submitData() {
      // this.isSubmit = !!noSubmit;
      return new Promise((resolve) => {
        this.$refs.patient.validate((valid) => {
          if (valid) {
            const res = utils.deepClone(this.data);
            res.patient.nation = res.patient.nationId && this.listNation.find(item => item.id === res.patient.nationId).name;
            res.patient.ethnicity = res.patient.ethnicityId && this.listEthnicity.find(item => item.id === res.patient.ethnicityId).name;
            res.patient = Object.assign(res.patient, this.exchangeLocation(res.patient.locationArr));
            resolve(res);
          }

          resolve(valid);
        });
      });
    },
    handleContentAdd(i) {
      this.data.patientOtherContactList.splice(i, 0, {});
    },
    handleContentDel(i) {
      this.data.patientOtherContactList.splice(i, 1);
    },
    getData(id) {
      base.patient.getPatientBaseInfo({ patientId: id, encrypt: !this.able }).then((res) => {
        if (res.data.status === 200) {
          this.data = res.data.data;
          const { provinceId, cityId, countyId } = this.data.patient;
          this.data.patient.locationArr = [
            provinceId, cityId, countyId,
          ];
          const { provinceName, cityName, countyName } = this.data.patient;
          this.data.patient.locationString = countyName ? `${provinceName}/${cityName}/${countyName}` : '';
          this.data.patient.nationId = this.data.patient.nationId || 1;

          if (!this.data.patientOtherContactList.length) {
            this.data.patientOtherContactList = [{}];
          }

          this.setRules(this.data.patient.permissionType);
          this.able && this.$nextTick(() => {
            this.$refs.patient.validateField('idCard');
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // getNation() {
    //   base.patient.getListNation();
    // },
    // getListEthnicity() {
    //   base.patient.getListEthnicity();
    // },
  },
  mounted() {
    Promise.all([
      base.patient.getListNation(),
      base.patient.getListEthnicity(),
    ]).then().catch((err) => {
      utils.handleError(err);
    });
    // this.getNation();
    // this.getListEthnicity();
    if (this.id) {
      this.getData(this.id);
    }
  },
};
</script>

<style lang="less" scoped>
.editRow{
  display: flex;
  justify-content: space-between;
  // margin-bottom: 8px;
  >*:first-child{
    width: 90%;
    >*{

      width: 33%;
    }
  }
}
</style>
